module.exports = __webpack_public_path__ + "media/styles/images/svg/baruch-logo_horizontal-gray-e39f1de5125d23cc75d274ac2c239a6c.svg";